import type { CSSProperties } from "react";

export const TEAM_CARD_RENDER_RADIUS = 5;

export const TEAM_CARD_DESKTOP_WIDTH = 570;
export const TEAM_CARD_DESKTOP_HEIGHT = 250;
export const TEAM_CARD_MOBILE_WIDTH = 340;
export const TEAM_CARD_MOBILE_HEIGHT = 250;

export const CARD_GAP_MOBILE_PX = 20;
export const CARD_GAP_DESKTOP_VW_FACTOR = 2;

export const HERO_TEAM_CARD_BACKGROUND = "rgba(0, 0, 0, 0.4)";
export const HERO_TEAM_CARD_CONTENT_BACKDROP_BLUR = 0;

export const SCROLL_SETTLED_DEBOUNCE_MS = 200;

export const ENTRANCE_STAGGER_DELAY_PER_PITCH = 0.06;
export const ENTRANCE_DURATION = 0.4;
export const ENTRANCE_EASE = [0.25, 0.1, 0.25, 1] as const;

export const SCALE_FALLOFF_PITCHES = 5;
export const SCALE_MIN = 0.55;
export const OPACITY_FALLOFF_PITCHES = 2;
export const OPACITY_MIN = 0.1;

export const PERSPECTIVE_PX = 1000;
export const ROTATE_Y_MAX_DEG = 45;
export const ROTATE_X_MAX_DEG = 0;
export const CTEAMSCAROUSEL_OVERSCROLL_BEHAVIOR_X_CONTAIN = "contain";
export const CTEAMSCAROUSEL_TOUCH_ACTION_PAN_X = "pan-x";

export const CARD_FILL_STYLE: CSSProperties = {
  width: "100%",
  height: "100%",
};
